// extracted by mini-css-extract-plugin
export default {"compare":"add_to_comparision_button___compare___fa4a0ab9","compared":"add_to_comparision_button___compared___a3a15147"};